import {sendDataLayerEvent} from './analytics';

const HUBSPOT_PORTAL_ID = '4532585';

export const loadFormScript = onLoadCallback => {
  const script = document.getElementById('hubspot-form-script');

  if (!script) {
    const script = document.createElement('script');
    script.setAttribute('type', 'text/javascript');
    script.setAttribute('src', '//js.hsforms.net/forms/v2.js');
    script.setAttribute('async', true);
    script.setAttribute('id', 'hubspot-form-script');
    script.onload = onLoadCallback;

    document.body.appendChild(script);
    return;
  }

  onLoadCallback();
};

const initiateHubSpotForm = (formId, targetSelector, submitButtonClass, onFormSubmitted) => {
  ($ => {
    hbspt.forms.create({
      portalId: HUBSPOT_PORTAL_ID,
      formId: formId,
      css: '',
      cssRequired: '',
      submitButtonClass: submitButtonClass,
      target: targetSelector,
      locale: 'en',
      translations: {
        en: {
          required: 'This field is required.'
        }
      },
      onFormReady: function () {
        $('input[name="metro_visitor_id__c"]').val(metroCookieId());
      },
      onFormSubmitted: function () {
        const $form = $('.hs-newsletter-form');
        $form.html(
          '<div class="submitted-message"><p>Thanks for subscribing, we’ll be in touch soon!</p></div>'
        );

        sendDataLayerEvent('Event', {
          eventCategory: 'Form',
          eventAction: 'Submitted',
          eventLabel: 'Newsletter Form Pop up - Resources'
        });

        if (typeof onFormSubmitted === 'function') onFormSubmitted();
      }
    });
  })(jQuery);
};

export const createHubSpotNewsletterForm = (
  formId,
  targetSelector,
  submitButtonClass,
  onFormSubmitted
) => {
  loadFormScript(() =>
    initiateHubSpotForm(formId, targetSelector, submitButtonClass, onFormSubmitted)
  );
};
